import { render, staticRenderFns } from "./initiative.vue?vue&type=template&id=24fd9a8e"
import script from "./initiative.vue?vue&type=script&lang=js"
export * from "./initiative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fd9a8e')) {
      api.createRecord('24fd9a8e', component.options)
    } else {
      api.reload('24fd9a8e', component.options)
    }
    module.hot.accept("./initiative.vue?vue&type=template&id=24fd9a8e", function () {
      api.rerender('24fd9a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/initiative.vue"
export default component.exports